var _a;
import { generateSelectors } from "../generators/generator.selectors";
import { GENERATOR_PARAMS } from "./rentRegistration.constants";
export var getDetail = (_a = generateSelectors(GENERATOR_PARAMS), _a.getDetail), isFetchingDetail = _a.isFetchingDetail, fetchDetailError = _a.fetchDetailError, getPaged = _a.getPaged, getCount = _a.getCount, isFetchingCount = _a.isFetchingCount, fetchCountError = _a.fetchCountError, getCreatedDetail = _a.getCreatedDetail, isCreating = _a.isCreating, createError = _a.createError, isUpdating = _a.isUpdating, updateError = _a.updateError, isRemoving = _a.isRemoving, removeError = _a.removeError;
export var isRetryingBrussels = function (state, id) {
    var _a, _b, _c, _d;
    return id !== undefined
        ? (_d = (_c = (_b = (_a = state[GENERATOR_PARAMS.reducerKey]) === null || _a === void 0 ? void 0 : _a.registrationsById) === null || _b === void 0 ? void 0 : _b[id]) === null || _c === void 0 ? void 0 : _c.isRetryingBrussels) !== null && _d !== void 0 ? _d : false
        : false;
};
export var brusselsRetryError = function (state, id) {
    var _a, _b, _c;
    return id !== undefined
        ? (_c = (_b = (_a = state[GENERATOR_PARAMS.reducerKey]) === null || _a === void 0 ? void 0 : _a.registrationsById) === null || _b === void 0 ? void 0 : _b[id]) === null || _c === void 0 ? void 0 : _c.brusselsRetryError
        : undefined;
};
export var isRetryingMyRent = function (state, id) {
    var _a, _b, _c, _d;
    return id !== undefined
        ? (_d = (_c = (_b = (_a = state[GENERATOR_PARAMS.reducerKey]) === null || _a === void 0 ? void 0 : _a.registrationsById) === null || _b === void 0 ? void 0 : _b[id]) === null || _c === void 0 ? void 0 : _c.isRetryingMyRent) !== null && _d !== void 0 ? _d : false
        : false;
};
export var myRentRetryError = function (state, id) {
    var _a, _b, _c;
    return id !== undefined
        ? (_c = (_b = (_a = state[GENERATOR_PARAMS.reducerKey]) === null || _a === void 0 ? void 0 : _a.registrationsById) === null || _b === void 0 ? void 0 : _b[id]) === null || _c === void 0 ? void 0 : _c.myRentRetryError
        : undefined;
};
export var getMyRentRetryResult = function (state) { var _a; return (_a = state[GENERATOR_PARAMS.reducerKey]) === null || _a === void 0 ? void 0 : _a.myRentRetryResult; };
